<template>
  <div class="app-calendar overflow-hidden border">

    <BOverlay
          variant="white"
          :show="showLoading"
          spinner-variant="primary"
          blur="0"
          opacity=".75"
          rounded="sm"
    >
      <!-- Filter -->
      <query-drop-down
        @refCalendar = "refetchEvents"
      />
      
      <div class="row no-gutters">
        <!-- Sidebar -->
        <div
          v-if = "false"
          class="col app-calendar-sidebar flex-grow-0 overflow-hidden d-flex flex-column"
          :class="{'show': isCalendarOverlaySidebarActive}"
        >
        <calendar-sidebar :is-event-handler-sidebar-active.sync="isEventHandlerSidebarActive" />
        </div>

        <!-- Calendar -->
        <div class="col position-relative">
          <div class="card shadow-none border-0 mb-0 rounded-0">
            <div class="card-body pb-0">
              <full-calendar
                ref="refCalendar"
                :options="calendarOptions"
                class="full-calendar"
              />
            </div>
          </div>
        </div>

        <!-- Sidebar Overlay -->
        <div
          class="body-content-overlay"
          :class="{'show': isCalendarOverlaySidebarActive}"
          @click="isCalendarOverlaySidebarActive = false"
        />
        <calendar-event-handler
          v-if = "false"
          v-model="isEventHandlerSidebarActive"
          :event="event"
          :clear-event-data="clearEventData"
          @remove-event="removeEvent"
          @add-event="addEvent"
          @update-event="updateEvent"
        />
      </div>

    </BOverlay>
    
  </div>
</template>

<script>
import { BOverlay } from "bootstrap-vue"
import FullCalendar from '@fullcalendar/vue'
import pageJs from './js'
import { onUnmounted, onMounted } from '@vue/composition-api'
import CalendarSidebar from '@/components/third-part/calendar-sidebar/CalendarSidebar.vue'
import CalendarEventHandler from '@/components/third-part/calendar-event-handler/CalendarEventHandler.vue'
import QueryDropDown from './components/query-dropdown/QueryDropDown.vue'
import tools from '@/sag-core/tools'
export default {
  components: {
    QueryDropDown,
    FullCalendar, // make the <FullCalendar> tag available
    CalendarSidebar,
    CalendarEventHandler,
    BOverlay,
  },
  setup() {

    const {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      refetchEvents,
      showLoading,
      calendarOptions,
      // ----- UI ----- //
      isEventHandlerSidebarActive,
    } = pageJs.page.pageInit()

    onMounted(()=>{
      console.log(refCalendar.value.getApi())
    })

    return {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      refetchEvents,
      showLoading,
      calendarOptions,
      // ----- UI ----- //
      isEventHandlerSidebarActive,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
</style>
